module.exports = __webpack_public_path__ + "img/lang.ca007be0.svg";